import React, {useState} from "react";
import MediaTable from "./MediaTable/MediaTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../utils/utils"

function MediaCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const {media_exposure} = props

    const news_data = (media_exposure.news_appearances || [])
        .flat()
        .map((news) => ({
            date: news.publication_date,
            title: news.news_title,
            font: news.source_name,
            link: news.url,
            label: news.sentimental_analysis,
            category: news.category,
        }))

    const negative_appearances =
        (media_exposure.total_negative_labeled_appearances || 0) +
        (media_exposure.total_slightly_negative_labeled_appearances || 0)
    const flag = negative_appearances > 0 ? "negative" : "positive"

    let initialExpand = flag !== "positive"
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard" style={{width: "100%"}}>
            <div style={{display:"flex"}}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    Mídias
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(flag)}
                </div>
                {news_data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
                }
            </div>
            {news_data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <MediaTable media_data={news_data}/>
                </div>
            </Collapse>
            }
        </div>
        );
}

export default MediaCard
